import { Action, bindActionCreators, Dispatch } from "redux";
import { connect } from "react-redux";
import { addVideo, extractText } from "../../../../redux/educator/actions";
import { setInitialSteps } from "../../../../redux/shared/actions";
import { StateType } from "../../../../utils/types";
import { selectExtractText } from "../../../../redux/educator/selector";

const mapStateToProps = (state: StateType) => ({
  extractedText: selectExtractText(state),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  actions: bindActionCreators(
    {
      addVideo,
      extractText,
      setInitialSteps,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
